import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center bg-background-50 px-4 py-20">
      <div className="max-w-lg text-center">
        <p className="font-label text-[12px] uppercase tracking-[0.3em] text-primary-600">
          Error 404 · Reel Missing
        </p>
        <h1 className="mt-4 font-heading text-4xl font-semibold text-foreground-950 md:text-5xl">
          这一卷胶片不在架上
        </h1>
        <p className="mt-4 text-sm leading-relaxed text-foreground-600">
          你访问的页面可能已经被移动，或者链接地址有误。可以回到首页，或者从电影分类重新开始浏览。
        </p>
        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-700 px-6 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-800"
          >
            返回首页
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            浏览电影分类
          </Link>
        </div>
      </div>
    </div>
  );
}